module.exports = __webpack_public_path__ + "img/download-whatsapp-status-video.29014437.webp";